import { LoadingText } from "@/constants/text.enum";

type TransactionLoadingStateParams = {
    approvalLoadingText: string;
    isApprovalLoading: boolean;
    isExecuting: boolean;
    actionLoadingText: string;
    isTransactionLoading: boolean;
};

export const getTransactionLoadingState = ({
    approvalLoadingText,
    isApprovalLoading,
    isExecuting,
    actionLoadingText,
    isTransactionLoading,
}: TransactionLoadingStateParams) => {
    const loadingText = (() => {
        if (approvalLoadingText) return approvalLoadingText;
        if (isExecuting) return actionLoadingText;
        if (isTransactionLoading || isApprovalLoading) return LoadingText.LOADING;
        return "";
    })();

    return {
        isLoading: isExecuting || isApprovalLoading || isTransactionLoading,
        loadingText,
    };
};
